export default __webpack_public_path__ + "static/media/faq_bg.99910dbc.png";